export interface ICampaignUrl {
    xSmallUrl: string,
    shortUrl: string,
    fullUrl: string
}